<template>
  <div class="acomodar">
    <button class="btn btn-danger mx-4 my-2" @click="retroceder">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        fill="currentColor"
        class="bi bi-skip-backward"
        viewBox="0 0 16 16"
      >
        <path
          d="M.5 3.5A.5.5 0 0 1 1 4v3.248l6.267-3.636c.52-.302 1.233.043 1.233.696v2.94l6.267-3.636c.52-.302 1.233.043 1.233.696v7.384c0 .653-.713.998-1.233.696L8.5 8.752v2.94c0 .653-.713.998-1.233.696L1 8.752V12a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5zm7 1.133L1.696 8 7.5 11.367V4.633zm7.5 0L9.196 8 15 11.367V4.633z"
        />
      </svg> RETROCEDER
    </button>

    <h2 class="mx-4 mt-4 text-secondary">ETAPA DOCUMENTOS:</h2>
    <div class="card bg-solimano pb-3 mt-3 mx-4">
      <form action="" v-if="perfilVisualizador == 9">
        <div class="row gx-5 px-5 card-body">
          <h4 v-if="documentoEscoger.length >0" class="mt-2 titulo mb-3 text-decoration-underline">
            Documentos:
          </h4>
          <div
            v-for="escoger in documentoEscoger"
            :key="escoger.id"
            class="col-lg-6 col-md-6"
          >
            <div class="shadow-lg p-3 mb-5 bg-white rounded mt-2">
              <div class="text-center titulo2">
                {{ escoger.parDescripcion }}
              </div>

              <div class="input-group">
                <input
                  type="file"
                  class="form-control mt-2"
                  aria-describedby="inputGroupFileAddon04"
                  multiple
                  required
                  aria-label="Upload"
                  @change="onFileSelected"
                />
                <button
                  class="btn btn-outline-success mt-2"
                  type="button"
                  id="inputGroupFileAddon04"
                  @click="onUpload($event)"
                  :value="escoger.parCorrelativo"
                >
                  cargar
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div class="row">
        <div class="col-lg-12">
          <div class="mx-5 mb-4">
            <h4 for="" class="mt-4 titulo">Documentos Pendientes:</h4>

            <textarea
              class="form-control text-danger"
              id="exampleFormControlTextarea1"
              disabled
              v-model="docPendiente"
              rows="3"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="card card-body bg-solimano mx-4 my-3">
        <div class="d-flex justify-content-end mx-4 mb-4">
          <label for="" class="mt-4"> Buscar:</label>
          <input
            class="form-control form-control-lg w-25 mx-4 mt-3"
            type="text"
            placeholder="Buscar por tipo de documento..."
            aria-label=".form-control-lg example"
            v-model="filterField"
          />
        </div>

        <!-- tabla -->
        <div class="table-responsive">
          <table
            v-if="filterField.length <= 0 ? cerrarTable1 : !cerrarTable1"
            class="table table-bordered"
          >
            <thead>
              <tr class="bg-solimano-table text-white text-center tamaño2">
                <th>ID</th>
                <th scope="col">TIPO DOCUMENTO</th>
                <th scope="col">DOCUMENTO</th>
                <th>RESPONSABLE DE CARGA</th>
                <th>AUDITORIA</th>
                <th v-if="cerrarPorSeguimiento" >ELIMINAR</th>
              </tr>
            </thead>
            <tbody
              v-for="(documentos, index) in documento.slice(
                NUM_RESULTS - 6,
                NUM_RESULTS
              )"
              :key="index.id"
            >
              <tr v-if="filterField.length < 1 ? true : false">
                <td>{{ documentos.idDocumento }}</td>
                <td>{{ documentos.nomTipoDocumento }}</td>
                <td class="text-center">
                  <a
                    :href="
                      url +
                      documentos.docAdjunto.slice(
                 54,
                        documentos.docAdjunto.length
                      )
                    "
                    target="_blank"
                    class="btn btn-ligth"
                  >
                   
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
                  </a>
                </td>
                <td class="text-center">{{ documentos.desProceso }}</td>
                <td class="text-center">{{ documentos.audCrea }}</td>

                <td v-if="cerrarPorSeguimiento" class="text-center">
                  <div class="mx-2">
                    <button
                      class="btn btn-danger"
                      @click="Eliminar(documentos.idDocumento)"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        class="bi bi-trash3 text-white"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"
                        />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- segunda tabla -->
          <div v-if="filterField.length > 0 ? !cerrarTable2 : cerrarTable2">
            <table class="table table-bordered">
              <thead>
                <tr class="bg-solimano-table text-white text-center tamaño2">
                  <th>ID</th>
                  <th scope="col">TIPO DOCUMENTO</th>
                  <th scope="col">DOCUMENTO</th>
                  <th>RESPONSABLE DE CARGA</th>
                  <th>AUDITORIA</th>
                  <th v-if="cerrarPorSeguimiento" >ELIMINAR</th>
                </tr>
              </thead>
              <tbody v-for="(documentos, index) in documento" :key="index.id">
                <tr v-if="filterField == documentos.idDocumento ? true : false">
                  <td>{{ documentos.idDocumento }}</td>
                  <td>{{ documentos.nomTipoDocumento }}</td>
                  <td class="text-center">
                    <!-- <a
                      :href="
                        url +
                        documentos.docAdjunto.slice(
                          61,
                          documentos.docAdjunto.length
                        )
                      "
                      target="_blank"
                      class="btn btn-white"
                    > -->
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="26"
                        fill="currentColor"
                        class="bi bi-file-pdf-fill text-danger"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M5.523 10.424c.14-.082.293-.162.459-.238a7.878 7.878 0 0 1-.45.606c-.28.337-.498.516-.635.572a.266.266 0 0 1-.035.012.282.282 0 0 1-.026-.044c-.056-.11-.054-.216.04-.36.106-.165.319-.354.647-.548zm2.455-1.647c-.119.025-.237.05-.356.078a21.035 21.035 0 0 0 .5-1.05 11.96 11.96 0 0 0 .51.858c-.217.032-.436.07-.654.114zm2.525.939a3.888 3.888 0 0 1-.435-.41c.228.005.434.022.612.054.317.057.466.147.518.209a.095.095 0 0 1 .026.064.436.436 0 0 1-.06.2.307.307 0 0 1-.094.124.107.107 0 0 1-.069.015c-.09-.003-.258-.066-.498-.256zM8.278 4.97c-.04.244-.108.524-.2.829a4.86 4.86 0 0 1-.089-.346c-.076-.353-.087-.63-.046-.822.038-.177.11-.248.196-.283a.517.517 0 0 1 .145-.04c.013.03.028.092.032.198.005.122-.007.277-.038.465z"
                        />
                        <path
                          fill-rule="evenodd"
                          d="M4 0h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm.165 11.668c.09.18.23.343.438.419.207.075.412.04.58-.03.318-.13.635-.436.926-.786.333-.401.683-.927 1.021-1.51a11.64 11.64 0 0 1 1.997-.406c.3.383.61.713.91.95.28.22.603.403.934.417a.856.856 0 0 0 .51-.138c.155-.101.27-.247.354-.416.09-.181.145-.37.138-.563a.844.844 0 0 0-.2-.518c-.226-.27-.596-.4-.96-.465a5.76 5.76 0 0 0-1.335-.05 10.954 10.954 0 0 1-.98-1.686c.25-.66.437-1.284.52-1.794.036-.218.055-.426.048-.614a1.238 1.238 0 0 0-.127-.538.7.7 0 0 0-.477-.365c-.202-.043-.41 0-.601.077-.377.15-.576.47-.651.823-.073.34-.04.736.046 1.136.088.406.238.848.43 1.295a19.707 19.707 0 0 1-1.062 2.227 7.662 7.662 0 0 0-1.482.645c-.37.22-.699.48-.897.787-.21.326-.275.714-.08 1.103z"
                        />
                      </svg>
                    <!-- </a> -->
                  </td>
                  <td class="text-center">{{ documentos.desProceso }}</td>
                  <td class="text-center">{{ documentos.audCrea }}</td>
                  <td v-if="cerrarPorSeguimiento" class="text-center">
                    <div class="mx-2">
                      <button
                        class="btn btn-danger"
                        @click="Eliminar(documentos.idDocumento)"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          class="bi bi-trash3 text-white"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"
                          />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="d-flex mt-3">
          <button
            class="btn btn-dark mx-4"
            @click="retroceso"
            :disabled="noRetroceder"
          >
            <span aria-hidden="true">{{retrocede}}</span>
          </button>
          <button class="btn btn-primary" :disabled="true">
            {{ pag }}
          </button>
          <button v-if="pag == Math.ceil(documento.length / 6) == false " class="btn btn-ligth">...</button>
          <button v-if="pag == Math.ceil(documento.length / 6) == false "  class="btn btn-primary">
            {{  Math.ceil(documento.length / 6)}}
          </button>
          <button
            class="btn btn-dark mx-4"
            @click="aumentar"
            :disabled="noAvanzar"
          >
            <span aria-hidden="true">{{avanza}}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapGetters } from 'vuex';

export default {
  name: "SolimanologDatosDocumentos",

  data() {
    return {
      vacio:"",
      retrocede:"<<",
      avanza:">>",
      filterField: "",
      url: "https://apitopas.gruposolimano.com.pe/Documentos/Postulacion/",
      cerrarTable1: true,
      cerrarTable2: false,
      NUM_RESULTS: 6,
      pag: 1,
      tipoDoc: "",
      idSolxPostulante: "",
      idUsuario: "",
      isdisabled: false,
      // retro: false,
      // avanzar: true,
      noAvanzar: false,
      noRetroceder: false,
      documento: [],
      documentoEscoger: [],
      docPendiente: "",
      selectedFile: null,
      cerrarPorSeguimiento:true,
      perfilVisualizador: null
    };
  },

  async mounted() {
    
    
    this.idSolxPostulante = this.$route.params.ContratoDoc;
    const humanos = localStorage.getItem("userId");
    this.permisoVisualizador =localStorage.getItem("idPerfil")

    let listado = await this.axios.get(
      `Documentos/OpcDocumentos?idSolxPostulant=${this.$route.params.ContratoDoc}&idUsuario=${humanos}`
    );

    this.documentoEscoger = listado.data;
    console.log('ddddd',this.documentoEscoger);
  },

  created() {
    this.getAttributes();
    this.atrributesGetters();
  },

  computed:{
    ...mapGetters('parametros', ['EstadoCiviles','Genero','Arreglar','DepartamentoDistrito','NacionEstado' , 'PaisEstado']),
    ...mapGetters("users", [
      "Items",
      "Permisos",
      "Contratos",
      "Tecnologia",
      "Operaciones",
      "Sst",
      "Bienestar",
      "Nominas",
      "Tesoreria",
      "Contabilidad",
      "Postulante"
    ]),
  },

  methods: {
    async atrributesGetters(){
      const humanos = localStorage.getItem("userId");
    let documentoPendiente = await this.axios.get(
      `Documentos/ValidarDocumentos?idSolxPostulante=${this.$route.params.ContratoDoc}&idUsuario=${humanos}`
    );
    this.docPendiente = documentoPendiente.data;
   
    },
    
    async getAttributes() {
      const humanos = localStorage.getItem("userId");
      let doc = await this.axios.get(
        `Documentos/ListarDocxUser?idSolxPostulante=${this.$route.params.ContratoDoc}&idUser=${humanos}`
      );
      console.log(doc.data);
      this.documento = doc.data;
    },

    retroceder() {
      window.history.back();
    },

    onFileSelected(event) {
      this.selectedFile = event.target.files[0];
    },

    onUpload(event) {

 
      // if ((this.selectedFile, length == 0)) {
      //   Swal.fire({
      //     icon: "error",
      //     title: "No has añadido ningun archivo",
      //     text: "",
      //     footer: "",
      //   });
      // }
      this.tipoDoc = event.target.value;
      console.log(this.tipoDoc)

      const fd = new FormData();
      fd.append("Archivo", this.selectedFile);
      fd.append("tipoDoc", this.tipoDoc);
      fd.append("idSolxPostulante", this.idSolxPostulante);
      fd.append("idProceso", this.idProceso);
      this.axios
        .post("Documentos/InsertarDocumento", fd)
        .then((r) => {
          console.log(r.data);
          if (r.data) {
            
            this.tipoDoc = "",
            this.selectedFile= ""
            let timerInterval;
            Swal.fire({
              title: "En Breve se cierra!",
              html: "<strong>Esta cargando <b></b> ....</strong>",
              timer: 2000,
              timerProgressBar: true,
              didOpen: () => {
                Swal.showLoading();
                const b = Swal.getHtmlContainer().querySelector("b");
                timerInterval = setInterval(() => {
                  b.textContent = Swal.getTimerLeft();
                }, 450);
              },
              willClose: () => {
                clearInterval(timerInterval);
              },
            }).then((result) => {
              /* Read more about handling dismissals below */
              if (result.dismiss === Swal.DismissReason.timer) {
                console.info("hola");
              }
            });
            this.getAttributes();
            this.atrributesGetters()
          }
        })
        .catch((error) => {
          console.log(error.response.status);
  
        });



      console.log(fd);
    },

    Eliminar(id) {
      Swal.fire({
        title: "Deseas Eliminar",
        // text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Elimar!",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire("¡Eliminado!", "El registro ha sido eliminado con éxito.", "success");
          this.axios
            .delete("Documentos/Eliminar/" + id)
            .then((r) => {
              console.log(r.data);
              this.getAttributes();
            });
        }
      });
    },

    pdfAbrir(mostrarPdf) {
      console.log(mostrarPdf);
      // var URL =  `file:///C:/`;

      // window.open(URL ,null );

      // console.log(URL)
    },

    retroceso() {
      if (this.NUM_RESULTS === 6) {
        // this.retro = false;
        //  this.avanzar = true;
        this.noRetroceder = true;
      } else {
        // this.retro = true;
        this.NUM_RESULTS -= 6;
        this.pag -= 1;
        this.noAvanzar = false;
        this.noRetroceder = false;
        //  this.avanzar = true
      }
    },

    aumentar() {
      this.NUM_RESULTS += 6;
      this.pag += 1;
      if (this.NUM_RESULTS > 6) {
        this.noRetroceder = false;
      } else {
        this.noRetroceder = true;
      }
      if (this.NUM_RESULTS > this.documento.length) {
        this.noAvanzar = true;
      }
      // console.log(this.NUM_RESULTS);
    },
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left: 2%;
  margin-right: 2%;
  height: auto;
  padding-bottom: 20px;
  border-radius: 10px 10px 10px 10px;
  overflow-x: none;
  overflow-y: none;
}
.textos {
  display: flex;
  justify-content: center;
  align-items: center;
}
.tamaño2 {
  font-size: 0.65rem;
  font-weight: 800;
}
.titulo {
  color: #0080c8;
  text-decoration: underline;
}
.titulo2 {
  color: #0080c8;
  font-weight: 600;
}

.bg-solimano {
  border-color: #0080c8;
  border-width: 2px;
}

.bg-solimano-table {
  background: #0080c8;
}

.pdfview {
  width: 500px;
  height: 400px;
}
</style>
